import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import supabase from '../../lib/supabase';
import { useAuth } from '../../lib/AuthContext';

const S = {
  page: { minHeight: '100vh', background: '#0f1115', padding: '24px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' },
  title: { fontSize: '24px', fontWeight: 800, color: '#fff' },
  nav: { display: 'flex', gap: '8px' },
  navBtn: { background: '#2a2d35', color: '#9ca3af', border: 'none', borderRadius: '8px', padding: '10px 16px', fontSize: '13px', fontWeight: 600, cursor: 'pointer', textDecoration: 'none' },
  navBtnActive: { background: '#00e701', color: '#000' },
  searchWrap: { display: 'flex', gap: '12px', marginBottom: '24px' },
  searchInput: { flex: 1, background: '#1a1d24', border: '1px solid #2a2d35', borderRadius: '8px', color: '#fff', fontSize: '14px', padding: '12px 16px', outline: 'none' },
  select: { background: '#1a1d24', border: '1px solid #2a2d35', borderRadius: '8px', color: '#fff', fontSize: '14px', padding: '12px 16px', outline: 'none', cursor: 'pointer' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '16px' },
  userCard: { background: '#1a1d24', borderRadius: '12px', padding: '20px', border: '1px solid #2a2d35' },
  userHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' },
  userName: { fontSize: '16px', fontWeight: 700, color: '#fff' },
  badge: { display: 'inline-block', borderRadius: '4px', padding: '4px 10px', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase' },
  badgeBanned: { background: 'rgba(255,68,68,0.15)', color: '#ff4444' },
  badgeActive: { background: 'rgba(0,231,1,0.15)', color: '#00e701' },
  badgeIpBanned: { background: 'rgba(255,68,68,0.2)', color: '#ff6666' },
  statRow: { display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #2a2d35', fontSize: '13px' },
  statLabel: { color: '#6b7280' },
  statVal: { color: '#fff', fontWeight: 600 },
  statGreen: { color: '#00e701' },
  statRed: { color: '#ff4444' },
  ipAddress: { fontFamily: 'monospace', fontSize: '12px', color: '#9ca3af', background: '#0f1115', padding: '4px 8px', borderRadius: '4px' },
  btnRow: { display: 'flex', gap: '8px', marginTop: '16px' },
  btn: { flex: 1, background: '#2a2d35', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px', fontSize: '12px', fontWeight: 600, cursor: 'pointer' },
  btnDanger: { background: '#ff4444', color: '#fff' },
  btnSuccess: { background: '#00e701', color: '#000' },
  btnIpBan: { background: '#9333ea', color: '#fff' },
  empty: { padding: '40px', textAlign: 'center', color: '#6b7280', fontSize: '14px' },
  modal: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modalCard: { background: '#1a1d24', borderRadius: '16px', padding: '24px', width: '450px', maxWidth: '90vw', border: '1px solid #2a2d35' },
  modalTitle: { fontSize: '18px', fontWeight: 700, color: '#fff', marginBottom: '16px' },
  statCard: { background: '#0f1115', borderRadius: '8px', padding: '16px', marginBottom: '16px' },
  statCardTitle: { fontSize: '12px', color: '#6b7280', marginBottom: '12px', textTransform: 'uppercase' },
  closeBtn: { width: '100%', background: '#2a2d35', color: '#fff', border: 'none', borderRadius: '8px', padding: '12px', fontSize: '14px', fontWeight: 600, cursor: 'pointer', marginTop: '16px' },
  input: { width: '100%', background: '#0f1115', border: '1px solid #2a2d35', borderRadius: '8px', color: '#fff', fontSize: '14px', padding: '10px 12px', outline: 'none', marginBottom: '12px' },
  confirmBtn: { width: '100%', background: '#ff4444', color: '#fff', border: 'none', borderRadius: '8px', padding: '12px', fontSize: '14px', fontWeight: 700, cursor: 'pointer', marginBottom: '8px' },
  tabRow: { display: 'flex', gap: '8px', marginBottom: '16px' },
  tab: { flex: 1, padding: '10px', borderRadius: '6px', border: 'none', background: '#0f1115', color: '#6b7280', fontSize: '12px', fontWeight: 600, cursor: 'pointer' },
  tabActive: { background: '#00e701', color: '#000' },
  ipList: { maxHeight: '150px', overflowY: 'auto', marginTop: '8px' },
  ipItem: { display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #2a2d35', fontSize: '12px' },
};

export default function AdminUsers() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userStats, setUserStats] = useState(null);
  const [userIPs, setUserIPs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [banReason, setBanReason] = useState('');
  const [userTab, setUserTab] = useState('stats');

  useEffect(() => {
    if (!user) {
      navigate('/betonmines/login');
      return;
    }
    loadUsers();
  }, [user, filter]);

  async function loadUsers() {
    setLoading(true);
    let query = supabase
      .from('users')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(100);

    if (filter === 'banned') {
      query = query.eq('banned', true);
    } else if (filter === 'active') {
      query = query.eq('banned', false).or('banned.is.null');
    }

    const { data } = await query;
    let filtered = data || [];
    
    if (search) {
      filtered = filtered.filter(u => 
        u.username.toLowerCase().includes(search.toLowerCase())
      );
    }

    setUsers(filtered);
    setLoading(false);
  }

  async function viewUser(userId, username) {
    setSelectedUser({ id: userId, username });
    setShowModal(true);
    setUserTab('stats');

    const { data: games } = await supabase
      .from('games')
      .select('*')
      .eq('user_id', userId);

    const { data: userData } = await supabase
      .from('users')
      .select('*')
      .eq('id', userId)
      .single();

    const { data: ips } = await supabase
      .from('user_ips')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false })
      .limit(20);

    setUserIPs(ips || []);

    if (games && userData) {
      const wins = games.filter(g => g.won);
      const losses = games.filter(g => !g.won);
      const totalWagered = games.reduce((s, g) => s + Number(g.bet_amount), 0);
      const totalPayout = wins.reduce((s, g) => s + Number(g.payout), 0);

      setUserStats({
        games: games.length,
        wins: wins.length,
        losses: losses.length,
        wagered: totalWagered,
        profit: totalPayout - totalWagered + wins.reduce((s, g) => s + Number(g.bet_amount), 0),
        balance: userData.balance,
        verified: userData.verified,
        banned: userData.banned || false,
        banReason: userData.ban_reason || '',
        ipBanned: userData.ip_banned || false,
        lastIp: userData.last_ip || 'N/A',
        created_at: userData.created_at,
      });
    }
  }

  async function toggleBan(userId, currentlyBanned) {
    await supabase
      .from('users')
      .update({ 
        banned: !currentlyBanned,
        ban_reason: currentlyBanned ? null : banReason
      })
      .eq('id', userId);

    setShowModal(false);
    setBanReason('');
    loadUsers();
  }

  async function banUserIP(ip) {
    if (!ip || ip === 'N/A') return;
    
    const { error } = await supabase
      .from('ip_bans')
      .insert([{
        ip_address: ip,
        banned_by: user.id,
        reason: `Banned via user panel`
      }]);

    if (!error) {
      const { data: sameIPUsers } = await supabase
        .from('user_ips')
        .select('user_id')
        .eq('ip_address', ip);

      const userIds = [...new Set((sameIPUsers || []).map(u => u.user_id))];
      
      for (const uid of userIds) {
        await supabase
          .from('users')
          .update({ banned: true, ban_reason: `IP banned: ${ip}` })
          .eq('id', uid);
      }

      setUserStats({ ...userStats, ipBanned: true });
      loadUsers();
    }
  }

  async function unbanIP(ip) {
    await supabase
      .from('ip_bans')
      .delete()
      .eq('ip_address', ip);

    setUserStats({ ...userStats, ipBanned: false });
  }

  return (
    <div style={S.page}>
      <div style={S.header}>
        <div style={S.title}>👥 User Management</div>
        <div style={S.nav}>
          <Link to="/betonmines" style={S.navBtn}>Withdrawals</Link>
          <Link to="/betonmines/users" style={{ ...S.navBtn, ...S.navBtnActive }}>Users</Link>
          <Link to="/betonmines/manage" style={S.navBtn}>Manage</Link>
        </div>
      </div>

      <div style={S.searchWrap}>
        <input
          style={S.searchInput}
          placeholder="Search by username..."
          value={search}
          onChange={e => { setSearch(e.target.value); loadUsers(); }}
        />
        <select style={S.select} value={filter} onChange={e => setFilter(e.target.value)}>
          <option value="all">All Users</option>
          <option value="active">Active</option>
          <option value="banned">Banned</option>
        </select>
      </div>

      <div style={S.grid}>
        {loading && <div style={{ ...S.empty, gridColumn: '1/-1' }}>Loading...</div>}
        {!loading && users.length === 0 && <div style={{ ...S.empty, gridColumn: '1/-1' }}>No users found</div>}
        {users.map(u => (
          <div key={u.id} style={S.userCard}>
            <div style={S.userHeader}>
              <span style={S.userName}>{u.username}</span>
              <span style={{ ...S.badge, ...(u.banned ? S.badgeBanned : S.badgeActive) }}>
                {u.banned ? 'Banned' : 'Active'}
              </span>
            </div>
            <div style={S.statRow}>
              <span style={S.statLabel}>Balance</span>
              <span style={S.statVal}>₿{Number(u.balance || 0).toFixed(2)}</span>
            </div>
            <div style={S.statRow}>
              <span style={S.statLabel}>Last IP</span>
              <span style={S.ipAddress}>{u.last_ip || 'N/A'}</span>
            </div>
            <div style={S.statRow}>
              <span style={S.statLabel}>Joined</span>
              <span style={S.statVal}>{new Date(u.created_at).toLocaleDateString()}</span>
            </div>
            <div style={S.btnRow}>
              <button style={S.btn} onClick={() => viewUser(u.id, u.username)}>View</button>
              <button 
                style={{ ...S.btn, ...(u.banned ? S.btnSuccess : S.btnDanger) }}
                onClick={() => { setSelectedUser(u); setShowModal(true); viewUser(u.id, u.username); }}
              >
                {u.banned ? 'Unban' : 'Ban'}
              </button>
            </div>
          </div>
        ))}
      </div>

      {showModal && selectedUser && userStats && (
        <div style={S.modal} onClick={() => setShowModal(false)}>
          <div style={{ ...S.modalCard, width: '500px' }} onClick={e => e.stopPropagation()}>
            <div style={S.modalTitle}>@{selectedUser.username}</div>

            <div style={S.tabRow}>
              <button style={{ ...S.tab, ...(userTab === 'stats' ? S.tabActive : {}) }} onClick={() => setUserTab('stats')}>Stats</button>
              <button style={{ ...S.tab, ...(userTab === 'ips' ? S.tabActive : {}) }} onClick={() => setUserTab('ips')}>IPs ({userIPs.length})</button>
            </div>

            {userTab === 'stats' && (
              <>
                <div style={S.statCard}>
                  <div style={S.statCardTitle}>Account</div>
                  <div style={S.statRow}>
                    <span style={S.statLabel}>Status</span>
                    <span style={{ ...S.badge, ...(userStats.banned ? S.badgeBanned : S.badgeActive) }}>
                      {userStats.banned ? 'Banned' : 'Active'}
                    </span>
                  </div>
                  <div style={S.statRow}>
                    <span style={S.statLabel}>Balance</span>
                    <span style={S.statVal}>₿{Number(userStats.balance || 0).toFixed(2)}</span>
                  </div>
                  <div style={S.statRow}>
                    <span style={S.statLabel}>Verified</span>
                    <span style={userStats.verified ? S.statGreen : S.statRed}>{userStats.verified ? 'Yes' : 'No'}</span>
                  </div>
                  <div style={S.statRow}>
                    <span style={S.statLabel}>Joined</span>
                    <span style={S.statVal}>{new Date(userStats.created_at).toLocaleDateString()}</span>
                  </div>
                  {userStats.banned && userStats.banReason && (
                    <div style={S.statRow}>
                      <span style={S.statLabel}>Ban Reason</span>
                      <span style={S.statRed}>{userStats.banReason}</span>
                    </div>
                  )}
                </div>

                <div style={S.statCard}>
                  <div style={S.statCardTitle}>Game Stats</div>
                  <div style={S.statRow}>
                    <span style={S.statLabel}>Total Games</span>
                    <span style={S.statVal}>{userStats.games}</span>
                  </div>
                  <div style={S.statRow}>
                    <span style={S.statLabel}>Wins</span>
                    <span style={S.statGreen}>{userStats.wins}</span>
                  </div>
                  <div style={S.statRow}>
                    <span style={S.statLabel}>Losses</span>
                    <span style={S.statRed}>{userStats.losses}</span>
                  </div>
                  <div style={S.statRow}>
                    <span style={S.statLabel}>Total Wagered</span>
                    <span style={S.statVal}>₿{userStats.wagered.toFixed(2)}</span>
                  </div>
                  <div style={S.statRow}>
                    <span style={S.statLabel}>Net Profit</span>
                    <span style={userStats.profit >= 0 ? S.statGreen : S.statRed}>
                      {userStats.profit >= 0 ? '+' : ''}₿{userStats.profit.toFixed(2)}
                    </span>
                  </div>
                </div>
              </>
            )}

            {userTab === 'ips' && (
              <div style={S.statCard}>
                <div style={S.statCardTitle}>IP Addresses ({userIPs.length})</div>
                <div style={S.ipList}>
                  {userIPs.length === 0 && <div style={{ color: '#6b7280', padding: '8px 0' }}>No IPs recorded</div>}
                  {userIPs.map((ip, i) => (
                    <div key={ip.id || i} style={S.ipItem}>
                      <span style={{ fontFamily: 'monospace', color: '#fff' }}>{ip.ip_address}</span>
                      <div style={{ display: 'flex', gap: '4px' }}>
                        <span style={{ fontSize: '10px', color: '#6b7280' }}>{new Date(ip.created_at).toLocaleDateString()}</span>
                        <button 
                          style={{ background: '#9333ea', color: '#fff', border: 'none', borderRadius: '4px', padding: '2px 6px', fontSize: '10px', cursor: 'pointer' }}
                          onClick={() => banUserIP(ip.ip_address)}
                        >
                          Ban IP
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                {userStats.lastIp && userStats.lastIp !== 'N/A' && (
                  <div style={{ marginTop: '12px', padding: '12px', background: '#1a1d24', borderRadius: '6px' }}>
                    <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '8px' }}>LAST KNOWN IP</div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontFamily: 'monospace', color: '#fff' }}>{userStats.lastIp}</span>
                      <button 
                        style={{ background: '#9333ea', color: '#fff', border: 'none', borderRadius: '4px', padding: '4px 8px', fontSize: '11px', cursor: 'pointer' }}
                        onClick={() => banUserIP(userStats.lastIp)}
                      >
                        Ban IP
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}

            {!userStats.banned && (
              <>
                <input
                  style={S.input}
                  placeholder="Ban reason (optional)"
                  value={banReason}
                  onChange={e => setBanReason(e.target.value)}
                />
                <button 
                  style={S.confirmBtn}
                  onClick={() => toggleBan(selectedUser.id, false)}
                >
                  Ban User
                </button>
              </>
            )}
            
            {userStats.banned && (
              <button 
                style={{ ...S.confirmBtn, background: '#00e701', color: '#000' }}
                onClick={() => toggleBan(selectedUser.id, true)}
              >
                Unban User
              </button>
            )}

            <button style={S.closeBtn} onClick={() => setShowModal(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
